import React from "react";

const ScreeningsIcon= () => {
  return (
     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.1654 17.4999H5.83203" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.33203 5V4.16667C3.33203 3.24583 4.07786 2.5 4.9987 2.5H14.9987C15.9195 2.5 16.6654 3.24583 16.6654 4.16667V8.33333H13.332L11.332 5.6L8.66536 11.0667L6.66536 8.33333H3.33203C3.33203 9.09167 3.33203 11.6683 3.33203 12.5C3.33203 13.4208 4.07786 14.1667 4.99786 14.1667C7.55953 14.1667 12.4379 14.1667 14.9995 14.1667C15.9195 14.1667 16.6654 13.4208 16.6654 12.5V11.6667" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     </svg>  
    );
};
export default ScreeningsIcon;